import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ palette }) => ({
    ui_module__container: {
        display: "flex",
        height: "100%",
        overflow: "hidden",
        padding: 0,
        maxWidth: 1920,
    },
    ui_module__screen_main: {
        flex: 1,
        overflowX: "visible",
        overflowY: "hidden",
    },
    "ui_module__screen_main--no_scroll": {
        overflowY: "hidden",
    },
    ui_module__screen_secondary: {
        background: palette.common.white,
        borderLeft: `solid 1px ${palette.divider}`,
        borderRight: `solid 1px ${palette.divider}`,
        overflowX: "visible",
        overflowY: "hidden",
        width: "50%",
        maxWidth: 500,
        zIndex: 1,
    },
}));
//# sourceMappingURL=ui_module.css.js.map